var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"contactBox"}},[_c('div',{staticClass:"verde"},[_c('img',{staticClass:"ligueCel",attrs:{"src":require("@images/paginas/fale-conosco/icons/celular.png")}}),_c('div',{staticClass:"numbers"},_vm._l((_vm.contents.content),function(item){return _c('span',{staticClass:"ligueVerde"},[_vm._v(_vm._s(item))])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }